import http from 'axios'
import { formatFiltresToAxiosParams } from './utils/filtres.utils'

export default {
  getTypesContrat: () => {
    return http.get(`/web/v1/contrat-vente/type-contrat`)
  },
  getTypesPrix: () => {
    return http.get(`/web/v1/contrat-vente/type-prix`)
  },
  getContractualisation: (username, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${username}/contrat-vente?anneeRecolte=${anneeRecolte}&codeTypeCulture=${codeTypeCulture}`)
  },
  createContratVente: (username, contratVenteACreer) => {
    return http.post(`/web/v1/${username}/contrat-vente`, contratVenteACreer)
  },
  updateContratVente: (username, contratVenteAModifier) => {
    return http.put(`/web/v1/${username}/contrat-vente`, contratVenteAModifier)
  },
  updateRepartitionContratVente: (username, idContratVente, repartition) => {
    return http.put(`/web/v1/${username}/contrat-vente/${idContratVente}/repartition`, repartition)
  },
  deleteContratVente: (username, idContratVenteASupprimer) => {
    return http.delete(`/web/v1/${username}/contrat-vente/${idContratVenteASupprimer}`)
  },
  getPrixVenteCulture: (username, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${username}/contrat-vente/${anneeRecolte}/prix-vente?codeTypeCulture=${codeTypeCulture}`)
  },
  construireResumeGroupeRepartitionPrixVente: (username, params) => {
    return http.get(`/web/v1/${username}/contrat-vente/${params.anneeRecolte}/prix-vente/repartition/groupe?codeTypeCulture=${params.codeGraine}&${formatFiltresToAxiosParams(params.filtres)}`)
  },
  getRepartitionTypeContrat: (username, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${username}/contrat-vente/${anneeRecolte}/type-contrat/repartition?codeTypeCulture=${codeTypeCulture}`)
  },
  getRepartitionTypeContratGroupe: (username, anneeRecolte, codeTypeCulture, filtres) => {
    return http.get(`/web/v1/${username}/contrat-vente/${anneeRecolte}/type-contrat/repartition/groupe?codeTypeCulture=${codeTypeCulture}&${formatFiltresToAxiosParams(filtres)}`)
  },
  getFiltresTypeContrat (username, anneeRecolte, codeTypeCulture) {
    return http.get(`/web/v1/${username}/contrat-vente/${anneeRecolte}/type-contrat/filtre?codeTypeCulture=${codeTypeCulture}`)
  },
  getEvolutionPrixVente: (username, anneeRecolte, codeTypeCulture, filtreTypeContrat) => {
    return http.get(`/web/v1/${username}/contrat-vente/${anneeRecolte}/prix-vente/evolution?codeTypeCulture=${codeTypeCulture}&filtreTypeContrat=${filtreTypeContrat}`)
  },
  construireResumeGroupeEvolutionPrixVente: (username, anneeRecolte, params) => {
    return http.get(`/web/v1/${username}/contrat-vente/${anneeRecolte}/prix-vente/evolution/repartition/groupe?codeTypeCulture=${params.codeGraine}&filtreTypeContrat=${params.codeTypeContrat}&${formatFiltresToAxiosParams(params.filtres)}`)
  }
}
